import React from "react";

class ApMobileAnnotationDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { type } = this.props;

    let title = "";
    let icon = null;

    switch (type) {
      case "point":
        title = "Punkt";
        icon = require("../../../media/AnnoType_Dot.png");
        break;
      case "area":
        title = "Fläche";
        icon = require("../../../media/AnnoType_Area.png");
        break;
      case "draw":
        title = "Zeichnen (N/A)";
        icon = require("../../../media/AnnoType_Draw.png");
        break;
    }

    return (
      <div
        className="ApMobileAnnotationDescription"
        onClick={() => this.props.onSelect()}
      >
        <div id="Head">
          <p>{title}</p>
        </div>
        <img alt="Icon" src={icon} />
        <div id="Foot">
          <p className="Link">Auswählen</p>
        </div>
      </div>
    );
  }
}

export default ApMobileAnnotationDescription;



// WEBPACK FOOTER //
// ./src/components/approval/mobile/ApMobileAnnotationDescription.js